// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"bd937f23","279":"bd937f23","534":"fd3eafc5","873":"75b2c110"}[chunkId] + ".css";
};